import { AboutBlock } from './components/login/AboutBlock';

export default function About() {
    return (
        <div className="w-full bg-surface-base" dir="rtl">
            {/* About Section */}
            <AboutBlock />

            {/* Copyright Footer */}
            <footer className="w-full text-center py-12 bg-surface border-t border-line-subtle">
                <p className="text-sm text-ink-subtle">
                    © {new Date().getFullYear()} המקומית. כל הזכויות שמורות.
                </p>
            </footer>

            {/* Global styles for smooth scrolling and animations */}
            <style>{`
                html {
                    scroll-behavior: smooth;
                }

                /* Enable hardware acceleration for better performance */
                section, .motion-div {
                    will-change: transform, opacity;
                    transform: translateZ(0);
                    -webkit-transform: translateZ(0);
                }
            `}</style>
        </div>
    );
}

